export const isValidURL = url => {
  try {
    return !!new URL(url)
  } catch (e) {
    return false
  }
}
